import moment from 'moment';
import _ from 'underscore';
import parseError from '../../parseError';

const createDayType = async ({ finalFormValidation, state, userId, updateState, addResourceDayType, Toast, refreshPage }) => {
  if (!finalFormValidation()) {
    return null;
  }
  const resourceId = state.resource.id;
  const { itemDetails } = state;
  const { dayTypeId, dayTypeComment, myDayTypeComment } = itemDetails;
  const date = moment(itemDetails.date).format('YYYY-MM-DD');
  const parameters = {
    date: moment(itemDetails.date).format('YYYY-MM-DD HH:mm:ss'), // should correct timezone issue Ramya is seeing...
    dayTypeId,
    resourceId,
    comment: dayTypeComment || ' ',
    myComment: myDayTypeComment || ' ',
    TKComment: ' ',
    userId
  };
  // store dayType parameters for optimistic re-render
  itemDetails.dayTypeParams = parameters;
  await updateState({itemDetails});
  // add new resource day type
  const { resource } = state;
  const day = moment(date).format('M/D/YYYY (ddd)');
  let notification = {type: 'success', message: 'Resource Day Type Added', description: `For ${resource.name} on ${day}`};
  try {
    await addResourceDayType(parameters);
  }
  catch(error) {
    if (!_.isEmpty(error)) {
      updateState({
        crudError: {
          failedAction: 'addResourceDayType',
          message: parseError(error)
        }
      });
      console.log(error);
      notification = {
        type: 'error',
        message: "Adding Resource Day Type Error",
        description: `For [${resource.name} on ${day}]: ${parseError(error)}`
      };
    }
  }
  await Toast(notification);
  refreshPage();

}

export default createDayType;



// WEBPACK FOOTER //
// ./src/Components/Schedule/LiveScheduleUpdate/utils/CRUD/dayType/createDayType.js